<template>
	<div>
		<div class="image-picker">
			<span :style="{backgroundImage:`url(${src})`}" class="color-template"></span>
			<btn modal-open="image-picker-modal"  label="Выбрать изображение"/>
		</div>

		<modal name="image-picker-modal" :noFooter="false" title="Выберите изображение">
			<tabs>
				<tab title="Из интернета" icon="globe">
					<inputi 
						label="Ссылка на изображение" 
						placeholder="http://" 
						:value="src" 
						@input="setSrc"
					/>
					<span 
						:style="{backgroundImage:`url(${src})`}"
						class="color-template"
					></span>
				</tab>
				<tab title="С компьютера" icon="laptop">
					<btn label="Выберите изображение"/>
					<div class="dropzone" 
						:class="{dragging:dragFileOver}" 
						@dragover="dragFileOver=true"
						@dragleave="dragFileOver=false"
						@drop="uploadFile"
					>
						<icon name="file" size="64" color="grey"/>
						<p v-if="!dragFileOver">
							Перетащите сюда файл
							<br> или кликните чтобы выбрать
						</p>
						<p v-if="dragFileOver">
							Бросай
							<br/>
							<br/>
						</p>
					</div>

					<span :style="{backgroundImage:`url(${src})`}" class="color-template"></span>
				</tab>
				<tab title="Из библиотеки Landos" icon="lib">

				</tab>
			</tabs>
			<div slot="footer">
				<btn s="m" label="Сохранить" t="p" @press="save"/>
			</div>
		</modal>
	</div>
</template>
<script>
	export default {
		name:"image-picker",
		props:{
			value:{
				type:String,
				default:"https://vuejs.org/images/logo.png"
			}
		},
		created(){
			this.src = this.value;
		},
		methods:{
	      uploadFile: function (e) {
	      	console.log("DROP");
	      },
			save(){
				//let {position='center', src, size='cover'} = this.value;
				//console.log(this.value)
				//this.$emit('input', {src,position,size});
				this.$emit('input', this.src);
			},
			setSrc(src){
				this.src = src;
				//let {position='center', src, size='cover'} = this.value;
				//this.$emit('input', Object.assign({},{position, src, size}, props));
				//this.$emit('input', this.src);
			}
		},
		computed:{
			computedImage(){
				let {src, size, position} = this.value;
				return `url(${src})`;
			}
		},
		data(){
			return {
				src:"",
				dragFileOver:false
			}
		}
	}
</script>
<style scoped>
	.slider{
		background: black;
		overflow:hidden;
		height:20px;
	}
	.point{
		height:24px;
		width:12px;
		background: green;
		position: absolute;
		border:3px solid white;
		border-radius: 3px;
		margin-top:-3px;
	}
	.image-picker{
		display: inline-block;
		vertical-align: middle;
	}
	.color-template{
		border:4px solid white;
		background-color: whitesmoke;
		border-radius: 5px;	
		width:240px;
		height:140px;
		margin:2px;
		display: inline-block;
		box-shadow: 0px 0px 1px grey;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}
	.modal{
		position: absolute;
	}
	.dropzone:hover{
		background: whitesmoke;
	}
	.dropzone{
		padding:40px;
		border:1px dashed grey;
		margin:10px 30px;
		text-align: center;
		border-radius: 10px;
		cursor: pointer;
	}
	.dropzone.dragging{
		background: whitesmoke;
	}


	.position-settings .break{
		margin-top:6px;
	}
</style>